import React, { useState, useEffect } from 'react';
import Loader from 'react-loader-spinner';
import { useHistory } from "react-router-dom";
import MaterialTable from "material-table";
import { baseUrl } from '../../../config';
import axiosIntance from '../../../helper/axios';
import { clickColor, inArray } from '../../../library/util';
import Sidebar from '../../Template/Sidebar/Sidebar';
import Header from '../../Template/Header/Header';

import { checkAccess, FEATURES } from '../../../library/auth'

function OfferFF() {

  const history = useHistory();
  if (localStorage.getItem('isLogin') === "false" || localStorage.getItem('isLogin') == null) {
    history.push('/')
  }
  if (!checkAccess(FEATURES.campaign_fulfillment)) {
    history.push('/');
  }

  const [reportData, setReportData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedrowList, setSelectedRowList] = useState([]);
  const [message, setMessage] = useState('')
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    handleRunReport();
  }, [])

  const handleSignOut = () => {
    window.localStorage.setItem('isLogin', false);
    history.push('/');
  }

  const handleSelectRow = (selectedRow) => {
    if (!inArray(selectedRow.tableData.id, selectedrowList)) {
      setSelectedRowList(oldArray => [...oldArray, selectedRow.tableData.id]);
      setSelectedRow(selectedRow.tableData.id)
      console.log(selectedrowList)
    } else {
      setSelectedRow(500000)
      setSelectedRowList([])
    }
  }

  const handleRunReport = () => {
    setMessage('');
    setLoader(true);

    axiosIntance.get(`${baseUrl}/reports/shippingreports/offerff`
      , {}).then(response => {
        setLoader(false);
        if (response.data.result.length > 0) {
          setReportData(response.data.result);
        } else {
          setReportData([]);
        }
      }).catch(error => {
        setLoader(false);
        setMessage('Something went wrong');
      });
  }

  return (
    <div id="wrapper" className>
      <Sidebar />
      <Header handleSignOut={handleSignOut} />

      <div className='errorMsg'>{message}</div>

      <section id="content-wrapper">
        {loader

          ? <div className='loaderDiv'>
            <Loader type="ThreeDots" color="#2BAD60" height="100" width="100" />
          </div>

          : <MaterialTable
            onRowClick={((evt, selectedRow) => handleSelectRow(selectedRow))}

            columns={[
              { title: "Name", field: "group" },
              { title: "ID", field: "group_id" },
              {
                title: "Fulfillment", field: "ff_alias", render: data =>
                  Array.isArray(data['ff_alias']) ? data['ff_alias'].join(' | ') : data['ff_alias']
              },
              { title: "Valid From", field: "ff_valid_from" },
              { title: "Orders last 30 days", field: "orders30days" },
            ]}

            data={reportData}

            parentChildData={(row, rows) => rows.find(r => r.key === row.parentKey)}

            title="Campaign Fulfillment"

            options={{
              actionsColumnIndex: -1,
              addRowPosition: "first",
              maxBodyHeight: '560px',
              paging: false,
              exportButton: true,
              headerStyle: { position: 'sticky', top: 0, fontSize: '17px', fontWeight: 'bold' },
              rowStyle: rowData => ({
                backgroundColor: (selectedRow === rowData.tableData.id) ? clickColor : '',
                fontWeight: (rowData.group === 'Total' ? 'bold' : 'inherit')
              })
            }}
          />
        }

      </section>

    </div>
  );
}

export default OfferFF
